import * as React from "react";
import { SVGProps } from "react";
const HeaderPatientSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25.811}
    height={25.81}
    {...props}
  >
    <g data-name="Group 3">
      <g
        fill="none"
        stroke={props.stroke ?? "#172b4d"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        data-name="Group 18208"
      >
        <path
          d="M0 10.083H.75A9.333 9.333 0 1 0 10.083.75 9.333 9.333 0 0 0 .75 10.083"
          data-name="Path 5486"
        />
        <path d="m24.75 24.749-8-8" data-name="Path 5487" />
      </g>
    </g>
  </svg>
);
export default HeaderPatientSearchIcon;
